import React, { Component } from 'react';
import { Redirect } from 'react-router-dom'; // Link
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Toast from '../../commons/helpers/toast';
// import CustomMultiSelect from '../../commons/helpers/customMultiSelect';
import {userGroupUrlCheck} from '../../../utils/userGroupUrlCheck';
import { checkNumDotZero } from '../../../utils/validation';

import { ROUTE_REFRESH, PAGENUMROWS_AFFILIATE,LOGIN_CLIENT_GROUP,LOGIN_AFFILIATE_GROUP } from '../../../configs/staticConfigs'; // LOGIN_AFFILIATE_GROUP, MSG_DATA_FETCH_CHIEF_BONUS_ERROR = "Failed to fetch Crew Chief data from the Server.";
import {  MSG_DEPT_RATECARD_UPDATE_SUCCESS, MSG_DEPT_RATECARD_UPDATE_ERROR, MSG_DEPT_RATECARD_ERROR } from '../../../configs/msgConfigs'; // MSG_REQUIRED MSG_NOT_VALID_ERROR MSG_PAYRATE_REQUIRED MSG_CHARGERATE_REQUIRED
import { LBL_EDIT, LBL_APP_NAME, LBL_SETTINGS, LBL_RATE_CARD, LBL_SAVE, LBL_SELECT, LBL_DEPARTMENT, LBL_SLNUM, LBL_DISC_PERCENTAGE } from '../../../configs/labelConfigs';

import { aflt_rateCardsAllAction, aflt_departmentRateCardsListAction, aflt_departmentRateCardsUpdateAction } from '../../../actions/settings/affiliates/aflt_rateCardsActions';

import {clearAction} from '../../../actions/commonActions';

import { RATE_CARDS_ALL_AFFILIATE_SUCCESS, DEPT_RATECARDS_LIST_SUCCESS, DEPT_RATECARDS_UPDATE_SUCCESS, DEPT_RATECARDS_UPDATE_ERROR  } from '../../../actions/';

class DepartmentRateCard extends Component {

    constructor(props){
        super(props)

        this.state = {
            editData:true, 
            deptRateCardsData:[],  
            rateCardsAll: [],  
            formErrorEmptyData:'',          
            clientId: this.props.clientId,
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true,      
            formClick:false,
            rateCardCalled: 0,
            reloadRateCard:0,
        }

        this.saveFormData   = this.saveFormData.bind(this);
        this.checkFormData = this.checkFormData.bind(this); 
    }

    enableEdit = (e)=>{
        e.preventDefault()
        this.setState({editData:true});
    }

    componentDidMount() {
        let userGroupData = userGroupUrlCheck(window.location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }

        let affiliateId = 0;  
        if(userGroup===LOGIN_AFFILIATE_GROUP){
            document.title = LBL_APP_NAME+" - "+LBL_SETTINGS+" - "+LBL_RATE_CARD;
            document.body.classList.add('body-affiliate'); 
            affiliateId = userGroupData.profile_id;
        }else if(userGroup===LOGIN_CLIENT_GROUP){
            document.body.classList.add('body-client');
        }

        this.props.aflt_rateCardsAllAction({pageSize:PAGENUMROWS_AFFILIATE,page:0,column:'title'}); 
        if(this.props.clientId && this.props.clientId > 0) {
            this.props.aflt_departmentRateCardsListAction({clientId:this.props.clientId}); 
        }
    }  

    onHandleRateCardChange = (e,deptId,fieldType) => {
        const {value}  = e.target;
        let fieldValue = value;
        if (value && value !== '' && !checkNumDotZero(value)) { fieldValue = ''; };
        // {"department": 157, "rate_card": 166, "discount_percentage": "0.00"}
        let rateCardId = fieldType==='raterCard' ? parseInt(fieldValue,10) : 0;
        let discPerc   = fieldType==='discPercentage' ? fieldValue : 0.00;
        let dLen = this.state.deptRateCardsData.length; 

        if(dLen===0) {
            this.setState({deptRateCardsData:[{'department':deptId, 'rate_card':rateCardId, 'discount_percentage': discPerc}],formErrorEmptyData:''}); 
        } else {
            let tmpDRData = this.state.deptRateCardsData;
            const index = this.state.deptRateCardsData.findIndex(drItem => drItem.department === deptId);
            if(index < 0) {
                this.setState({deptRateCardsData:[...tmpDRData,{'department':deptId, 'rate_card':rateCardId, 'discount_percentage': discPerc}],formErrorEmptyData:''});  
            } else { 
                tmpDRData[index] = {
                    'department':deptId, 
                    'rate_card':fieldType==='raterCard'?rateCardId:tmpDRData[index].rate_card, 'discount_percentage':fieldType==='discPercentage'?discPerc:tmpDRData[index].discount_percentage
                }; 
                this.setState({deptRateCardsData:tmpDRData,formErrorEmptyData:''});  
            }
        }
    }
    
    checkFormData() {
        if(this.state.deptRateCardsData.length===0) {   
            this.setState({formErrorEmptyData:MSG_DEPT_RATECARD_ERROR});  
            return false; 
        } 
        else {
            this.setState({formErrorEmptyData:''});  
            return true; 
        }
    }
  
    saveFormData = (e)=>{
        if(e) e.preventDefault();
        if(this.checkFormData()) {
            // CHECK WHEHTER PERCENTAGE VALUE IS BETWEEN 0 AND 100 
            const index = this.state.deptRateCardsData.findIndex(drItem => (drItem.discount_percentage.toString().trim()=='' || parseInt(drItem.discount_percentage,10) < 0 || parseInt(drItem.discount_percentage,10) > 100));
            if(index < 0 ) {
                this.props.aflt_departmentRateCardsUpdateAction({
                    clientId : this.props.clientId,
                    deptRateCardsData: this.state.deptRateCardsData
                }); 
                this.setState({formClick:false});
            } else {
                return false; 
            }
        }
    }

    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:'',toastSuccess:true});
    } 

    componentDidUpdate(prevProps) {      
        const { reloadRateCard } = this.props; 
        const { status, activity } = this.props;

        if(this.props.clientId && this.props.clientId > 0 && prevProps.clientId!==this.props.clientId) {
            this.props.aflt_departmentRateCardsListAction({clientId:this.props.clientId}); 
        }

        if (activity && (status !== prevProps.status || activity!==prevProps.activity)) {
            if(status!==401) {   
                var arrResp = activity.split('~~'); 
                var actString = arrResp[0]; 

                if(actString===RATE_CARDS_ALL_AFFILIATE_SUCCESS){
                    if(this.props.hasOwnProperty('rateCardsAll')) {
                        if(this.props.rateCardsAll.length===0) {
                            this.setState({rateCardsAll: []}); 
                        }
                        else {
                            this.setState({rateCardsAll: this.props.rateCardsAll}); 
                        }
                    } 
                    else {
                        this.setState({rateCardsAll: []}); 
                    }
                } 

                if(actString===DEPT_RATECARDS_LIST_SUCCESS){
                    if(this.props.hasOwnProperty('deptRateCardsData')) {
                        if(this.props.deptRateCardsData.length===0) {
                            this.setState({deptRateCardsData: []}); 
                        }
                        else {
                            this.setState({deptRateCardsData: this.props.deptRateCardsData}); 
                        }
                    } 
                    else {
                        this.setState({deptRateCardsData: []}); 
                    }
                } // MSG_DEPT_RATECARD_UPDATE_SUCCESS, MSG_DEPT_RATECARD_UPDATE_ERROR

                if(actString===DEPT_RATECARDS_UPDATE_SUCCESS){ 
                    this.setState({toastSuccess:true, toastFlag:true,toastMessage:MSG_DEPT_RATECARD_UPDATE_SUCCESS});
                    setTimeout(()=> {
                        this.onCloseToast(); 
                    }, 3000);
                    // this.setState({editData:false});
                }
                else if(actString===DEPT_RATECARDS_UPDATE_ERROR) { 
                    this.setState({toastSuccess:false, toastFlag:true, toastMessage:MSG_DEPT_RATECARD_UPDATE_ERROR}); 
                    setTimeout(()=> {
                        this.onCloseToast(); 
                    }, 3000);
                }  

            }
        }
    }

    render(){
        const { status,departmentsList,clientDepartmentsList } = this.props;
        const { editData,formErrorEmptyData } = this.state;
        let isSuperAdmin = this.props.isSuperAdmin ? this.props.isSuperAdmin : false;
        let { toastMessage, toastFlag, toastSuccess } = this.state;        

        if(status===401 || status===403){
            return <Redirect to={ROUTE_REFRESH} />;
        }
        
        let slNum = 0; 

        return(
            <div className="form-group col-md-12">
                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
                {/* <div>{'deptRateCardsData: ',JSON.stringify(this.state.deptRateCardsData)}</div> */}
                <div className="form-group">
                    <div className="box margin-top-12">                         
                        <div className="tab-head">
                            <div className="table-responsive">
                             <table id="data-table" className='table  width-100-percent'  >
                                 <thead>
                                 <tr className="text-bold">
                                     <th className="text-center">{LBL_SLNUM}</th>
                                     <th className="text-left">{LBL_DEPARTMENT}</th>
                                     <th className="text-left">{LBL_RATE_CARD}</th>
                                     <th className="text-center">{LBL_DISC_PERCENTAGE}</th>
                                 </tr>
                                 </thead> 
                                 <tbody>
                                 
                                {departmentsList.map( (deptObj,deptIndex) => {  
                                    if(clientDepartmentsList.includes(deptObj.id)){ 
                                        slNum++; 
                                        let selRateCardId = 0;
                                        let discPerc = 0.00; 
                                        let drArr = this.state.deptRateCardsData.filter(drItem => drItem.department===deptObj.id);
                                        if(drArr && drArr.length) {
                                            selRateCardId = drArr[0].rate_card;
                                            discPerc = drArr[0].discount_percentage; 
                                        }

                                        return( 
                                        <tr key={deptIndex}> 
                                            <td className="text-center">{slNum}</td> 
                                            <td className="text-left">{deptObj.name}</td>
                                            <td className="text-center">
                                                <div className="form-group select-input">
                                                    <select name={"selRateCard_"+deptObj.id} onChange={((e)=>this.onHandleRateCardChange(e,deptObj.id,'raterCard'))} disabled={this.props.isSuper} value={selRateCardId} >
                                                        <option value='0'>{LBL_SELECT+' '+LBL_RATE_CARD}</option>
                                                        {this.state.rateCardsAll.map((item) => {
                                                            return(<option key={item.id} value={item.id} >{item.title}</option>);     
                                                        })}
                                                    </select>
                                                </div> 
                                            </td>
                                            <td className="text-center">
                                                <input type="text" placeholder="Percentage" id={"txtDiscPercentage_"+deptObj.id} name={"txtDiscPercentage_"+deptObj.id} onChange={(e) => this.onHandleRateCardChange(e, deptObj.id,'discPercentage')} value={discPerc} maxLength={6} className={(discPerc.toString().trim()=='' || parseInt(discPerc,10) > 100) ? ' text-num-75 input-error ' : ' text-num-75 '} /> %
                                            </td>
                                        </tr>
                                        )} 
                                    })  
                                }

                                {clientDepartmentsList && clientDepartmentsList.length > 0 && <tr>
                                     <td colSpan="4" className="text-right width-100-percent">
                                         {this.state.formErrorEmptyData.length > 1 && 
                                         <div className="text-red to-right text-right width-100-percent"><small>{this.state.formErrorEmptyData}</small></div>}
                                         <div className="divFloatRight">
                                             <button className="btn btn-primary  saveBtnMinWidth" onClick={this.state.editData?this.saveFormData:this.enableEdit} > {this.state.editData?LBL_SAVE:LBL_EDIT}</button>
                                         </div> 
                                     </td>
                                 </tr>}
                                 
                                 </tbody>
                             </table>
                            
                             </div>
                         </div>    
                     </div>  
                    
                    

                    <div className="padding-top-50">&nbsp;</div>                           
                        
                </div>
                
            </div>
        )
    }

}
const mapStateToProps = (state) => {
    // console.log('state.afltRateCards.deptRateCardsData: ',state.afltRateCards.deptRateCardsData); 
    return {
        rateCardsAll : state.afltRateCards.rateCardsAll, 
        deptRateCardsData: state.afltRateCards.deptRateCardsData, 
        status:state.afltRateCards.status,
        activity:state.afltRateCards.activity,
        errorData: state.afltRateCards.errorData,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        aflt_rateCardsAllAction:data=>aflt_rateCardsAllAction(data), 
        aflt_departmentRateCardsListAction:data=>aflt_departmentRateCardsListAction(data),
        aflt_departmentRateCardsUpdateAction:data=>aflt_departmentRateCardsUpdateAction(data), 
        clearAction:clearAction
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(DepartmentRateCard);
